export default __webpack_public_path__ + "static/media/lines.6a2b2978.png";